import { render, staticRenderFns } from "./RevPrintWrapper.vue?vue&type=template&id=5d8bd996&scoped=true"
import script from "./RevPrintWrapper.vue?vue&type=script&lang=js"
export * from "./RevPrintWrapper.vue?vue&type=script&lang=js"
import style0 from "./RevPrintWrapper.vue?vue&type=style&index=0&id=5d8bd996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8bd996",
  null
  
)

export default component.exports